import * as Excel from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';

export const downloadChargingStation = async (poiResult, area) => {
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet('SPKLU');
  worksheet.columns = [
    { header: 'Province', key: 'nama_provinsi' },
    { header: 'City', key: 'nama_kota' },
    { header: 'District', key: 'nama_kecamatan' },
    { header: 'Address', key: 'address' },
    { header: 'Group', key: 'group_name' },
    { header: 'Category', key: 'category_name' },
    { header: 'Brand', key: 'brand_name' },
    { header: 'Station', key: 'station' },
    { header: 'Type', key: 'type' },
    { header: 'Total', key: 'total' },
    { header: 'Fee (Rp/kWh)', key: 'fee' },
    { header: 'Type of Current', key: 'type_of_current' },
    { header: 'Voltage (kW)', key: 'voltage' },
    { header: 'Fast Charger', key: 'fast_charger' },
  ];
  worksheet.getRow(1).font = { bold: true };
  if (poiResult.features.length > 0) {
    poiResult.features.forEach((feature) => {
      worksheet.addRow({
        nama_provinsi: feature?.properties?.nama_provinsi || 'N/A',
        nama_kota: feature?.properties?.nama_kota || 'N/A',
        nama_kecamatan: feature?.properties?.nama_kecamatan || 'N/A',
        address:
            (feature?.properties?.address || '')?.replace(
              /(&[a-zA-Z0-9#]+;)|,/g,
              ''
            ) || 'N/A',
        group_name: feature?.properties?.group_name || 'N/A',
        category_name: feature?.properties?.category_name || 'N/A',
        brand_name: feature?.properties?.brand_name || 'N/A',
        station: feature?.properties?.station || 'N/A',
        type: feature?.properties?.type || 'N/A',
        total: feature?.properties?.total || 'N/A',
        fee: feature?.properties?.fee || 'N/A',
        type_of_current: feature?.properties?.type_of_current || 'N/A',
        voltage: feature?.properties?.voltage || 'N/A',
        fast_charger: feature?.properties?.fast_charger || 'N/A',
      });
    });
  }
  const buffer = await workbook.xlsx.writeBuffer();
  const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const fileExtension = '.xlsx';

  const blob = new Blob([buffer], { type: fileType });

  saveAs(
    blob,
    `SPKLU - ${area} - ${moment().format('DDMMYYYYHHmmss')}` + fileExtension
  );
};
